import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import {catchError} from 'rxjs/operators';

@Injectable()
export class AppSummaryService extends BaseHttpService {

    fetch(brandId: string, itemId: string): Observable<any> {
        return this.http.get(Config.API + '/app-summaries/' + brandId + '/' + itemId)
            .pipe(catchError(this.handleError.bind(this)));
    }

}
